import { Box, Heading, Text, VStack } from 'native-base'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorImage } from '../../../components/images/Error'
import { Screen } from '../../../components/ScreenWrapper/Screen'

import { EmailSupportButton } from './EmailSupportButton'
import { WhatsappSupportButton } from './WhatsappSupportButton'

export const CustomSupportView = () => {
  const { t } = useTranslation()

  return (
    <Screen>
      <VStack space="4" height={'100%'} paddingBottom={5}>
        <Box>
          <Heading fontSize={'lg'} color={'neutral.900'}>
            {t('screens.support.subTitle')}
          </Heading>
        </Box>
        <Box>
          <Text fontSize={'md'} color={'gray.700'}>
            {t('screens.support.description')}
          </Text>
        </Box>
        <VStack style={{ transform: 'scale(0.60)' }} height={200} justifyContent={'center'} alignItems={'center'}>
          <ErrorImage size={200} />
        </VStack>
        <VStack space="4">
          <EmailSupportButton />
          <WhatsappSupportButton />
        </VStack>
      </VStack>
    </Screen>
  )
}
